// extracted by mini-css-extract-plugin
module.exports = {"categories":"index_categories_vrURp","category":"index_category_3SaYb","current":"index_current_1k9Qg"};